<template>
  <div class="about page-single">
    <h1 class="bigtitle">{{page.title.rendered}}</h1>
    <div class="page-inner" v-html="page.content.rendered"></div>
  </div>
</template>
<script>
export default {
  name: 'About',
  data () {
    return {
      page:""
    }
  },
  mounted () {
    this.axios
      .get('https://api.rocidesign.com/wp-json/wp/v2/pages/9')
      .then((response) => {
        this.page = response.data
      })
  }
}
</script>
